export default __webpack_public_path__ + "static/media/LogoRadiance.a65e6b50.png";